export default __webpack_public_path__ + "static/media/free-web.9aeb81c3.png";